import React, { Component } from "react";
import * as Yup from "yup";
import _ from "lodash";
import FormGrid, { FormGridField } from "./FormGrid";
import FormWrapper from "./FormWrapper";
import { FormUtils } from "..";

export interface FormBox {
    fields: FormGridField[];
    title?: string;
    columnClass: string;
    key?: string;
}

export interface FormBoxesProps {
    boxes: FormBox[];
    initialValues?: any;
    onChange: (...args: any) => any;
    validateOnUpdate?: boolean;
    isConfig?: boolean;
}

export interface FormBoxesState {
    boxes: FormBox[];
    validation: Yup.Schema<any>;
}

class FormBoxes extends Component<FormBoxesProps, FormBoxesState> {
    constructor(props) {
        super(props);

        this.state = {
            boxes: this.props.boxes.map(box => ({
                ...box,
                key: _.uniqueId()
            })),
            validation: FormBoxes.generateValidator(this.props.boxes)
        };
    }

    static generateValidator(boxes: FormBox[]): Yup.Schema<any> {
        return Yup.object().shape(
            boxes
                .flatMap(box => box.fields)
                .reduce((accumulator, field) => {
                    return {
                        ...accumulator,
                        [field.name]: field.validationSchema
                            ? FormUtils.generateYupValidatorFromSchema(
                                  field.validationSchema
                              )
                            : field.validation
                    };
                }, {})
        );
    }

    /*componentDidUpdate(prevProps) {
        if (
            this.props.validateOnUpdate &&
            prevProps.boxes[0].fields !== this.props.boxes[0].fields
        ) {
            console.log(prevProps, this.props);
        }
    }*/

    onChange = ({ values, isValid }) => {
        this.props.onChange({
            values,
            isValid
        });
    };

    renderFields(fields) {
        return <FormGrid fields={fields} isConfig={this.props.isConfig} />;
    }

    static getDerivedStateFromProps(props: FormBoxesProps, state) {
        const previousFields = props.boxes
            .flatMap(box => box.fields)
            .map(field => ({
                id: field.fieldOptions.id,
                disabled: field.fieldOptions.disabled
            }));

        const currentFields = state.boxes
            .flatMap(box => box.fields)
            .map(field => ({
                id: field.fieldOptions.id,
                disabled: field.fieldOptions.disabled
            }));

        if (!_.isEqual(previousFields, currentFields)) {
            return {
                boxes: props.boxes.map(box => ({
                    ...box,
                    key: box.key || _.uniqueId()
                })),
                validation: FormBoxes.generateValidator(props.boxes)
            };
        }
        return null;
    }

    renderBoxes() {
        return this.state.boxes.map(box => (
            <div className={box.columnClass} key={box.key}>
                <div className="inner-card">
                    {box.title && (
                        <div className="inner-card-title">{box.title}</div>
                    )}

                    <div className="inner-card-content">
                        {this.renderFields(box.fields)}
                    </div>
                </div>
            </div>
        ));
    }

    render() {
        return (
            <FormWrapper
                initialValues={this.props.initialValues || {}}
                onChange={this.onChange}
                validateOnUpdate={this.props.validateOnUpdate}
                validation={this.state.validation}
                fields={this.state.boxes.flatMap(box => box.fields)}
            >
                <div className="row">{this.renderBoxes()}</div>
            </FormWrapper>
        );
    }
}

export default FormBoxes;
